import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Dynamic redux
export var reduxModuleLoaded = createAction("".concat(actionKey, ".REDUX_READY"), function () { return ({}); });
export var openNftLinkPopup = createAction("".concat(actionKey, ".OPEN_NFT_LINK_POPUP"), function (deviation) { return ({ deviation: deviation }); });
export var deleteNft = createAction("".concat(actionKey, ".DELETE_NFT"), function (deviation, nft) { return ({ deviation: deviation, nft: nft }); });
export var updateNft = createAction("".concat(actionKey, ".UPDATE_NFT"), function (deviation, nftData) { return ({ deviation: deviation, nftData: nftData }); });
//# sourceMappingURL=actions.js.map